var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 6.64062L14.3432 2.65678L10.3594 2.65625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56055 7.43945L14.3418 2.6582",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 9.5625V13.8125C12.2188 13.9534 12.1628 14.0885 12.0632 14.1882C11.9635 14.2878 11.8284 14.3438 11.6875 14.3438H3.1875C3.0466 14.3438 2.91148 14.2878 2.81185 14.1882C2.71222 14.0885 2.65625 13.9534 2.65625 13.8125V5.3125C2.65625 5.1716 2.71222 5.03648 2.81185 4.93685C2.91148 4.83722 3.0466 4.78125 3.1875 4.78125H7.4375",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquare);
export default __webpack_public_path__ + "static/media/arrow-square.9f7c0256aa7ec7ce57524737a3b2a093.svg";
export { ForwardRef as ReactComponent };